import { t } from '@lingui/core/macro';
import { SearchAggregationMetricType } from 'shared/domains/apollo/generated/types';
export function getMetricTypeTranslations(key) {
    if (!key) {
        return '';
    }
    const translations = {
        [SearchAggregationMetricType.Avg]: t({
            message: 'Average',
            comment: 'Insights - Translation for Metric aggregation - type input',
        }),
        [SearchAggregationMetricType.Max]: t({
            message: 'Maximum',
            comment: 'Insights - Translation for Metric aggregation - type input',
        }),
        [SearchAggregationMetricType.Min]: t({
            message: 'Minimum',
            comment: 'Insights - Translation for Metric aggregation - type input',
        }),
        [SearchAggregationMetricType.Sum]: t({
            message: 'Sum',
            comment: 'Insights - Translation for Metric aggregation - type input',
        }),
        [SearchAggregationMetricType.Cardinality]: t({
            message: 'Cardinality',
            comment: 'Insights - Translation for Metric aggregation - type input',
        }),
        [SearchAggregationMetricType.ValueCount]: t({
            message: 'Value Count',
            comment: 'Insights - Translation for Metric aggregation - type input',
        }),
    };
    return translations[key];
}
